import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEOrthoTargetType = {
    anatomy:        'anatomy',
    head:           'head'
};

OEOrthoTargetType.all = [
    OEOrthoTargetType.anatomy,
    OEOrthoTargetType.head
];

export const OEOrthoStartSelectionContent = {
    [OEOrthoTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
// @ADD_TARGET_ORTHO_TARGETMENU
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanChestWall,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine
                    ]
                }
            ]
        }
    ],
    [OEOrthoTargetType.head]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanHead
                    ]
                }
            ]
        }
    ],

    [OEOrthoTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
// @ADD_TARGET_ORTHO_TARGETMENU
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanChestWall,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine
                    ]
                }
            ]
        }
    ],
    [OEOrthoTargetType.head]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanHead
                    ]
                }
            ]
        }
    ],

    [OEOrthoTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
// @ADD_TARGET_ORTHO_TARGETMENU
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanChestWall,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine
                    ]
                }
            ]
        }
    ],
    [OEOrthoTargetType.head]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanHead
                    ]
                }
            ]
        }
    ]
};

OEOrthoStartSelectionContent.modules = [
    {id: OEOrthoTargetType.anatomy, icon: OEIconCodes.ortho.anatomyTarget, categories: OEOrthoStartSelectionContent[OEOrthoTargetType.anatomy]},
    {id: OEOrthoTargetType.head, icon: OEIconCodes.ortho.headTarget, categories: OEOrthoStartSelectionContent[OEOrthoTargetType.head]}
];

OEOrthoStartSelectionContent.modulesBeta = [
    {id: OEOrthoTargetType.anatomy, icon: OEIconCodes.ortho.anatomyTarget, categories: OEOrthoStartSelectionContent[OEOrthoTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
    {id: OEOrthoTargetType.head, icon: OEIconCodes.ortho.headTarget, categories: OEOrthoStartSelectionContent[OEOrthoTargetType.head + OEAlphaBetaProdTypes.beta]}
];

OEOrthoStartSelectionContent.modulesProduction = [
    {id: OEOrthoTargetType.anatomy, icon: OEIconCodes.ortho.anatomyTarget, categories: OEOrthoStartSelectionContent[OEOrthoTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
    {id: OEOrthoTargetType.head, icon: OEIconCodes.ortho.headTarget, categories: OEOrthoStartSelectionContent[OEOrthoTargetType.head + OEAlphaBetaProdTypes.prod]}
];